import React, { useContext, memo } from "react";

import { IconButton } from "@material-ui/core";
import { ErrorOutline, Close } from "@material-ui/icons";

import Context from "../Context";

function AdditionalInformationModal({ message }) {
    const { modalOpen, handleModalOpen } = useContext(Context);

    return (
        <div className="c-modal">
            <button
                onClick={() => handleModalOpen(true)}
                className="c-modal__trigger"
                aria-label="Open"
            >
                <ErrorOutline />
            </button>

            <div
                className={`c-modal__wrapper${modalOpen ? " c-modal__wrapper--active" : ""}`}
                onClick={() => handleModalOpen(false)}
            >
                <IconButton
                    onClick={() => handleModalOpen(false)}
                    className="c-modal__close"
                >
                    <Close />
                </IconButton>

                <div className="c-modal__content">
                    {message.map((item) => (
                        <p>{item}</p>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default memo(AdditionalInformationModal);
